import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../../types/types';
import { CARD_FORM, CARD_FORM_STATUS } from '../form-card-type';
import { getParameters } from '../../../../helpers/helpers';
import { dropdown } from '../../../dropdown';
import useAuth from '../../../../hooks/auth-hooks';
import { displayCardInfo } from './display-card-info';
import { updateExistingCard } from './update-existing-card';
import { changeCustomerCardGroup } from './existing-card-helpers';

import GetCardIndividual from '../../../../routes/get-individual-card';
import GetCustomers from '../../../../routes/get-customers';
import GetCardGroups from '../../../../routes/get-card-groups';

/**
 * Function that displays the individual card information
 * 
 * @returns void
 */
const HandleViewOrEditCard = async () => {
  const cardNumber = getParameters('card');
  const customer = getParameters('custID');

  const { accessType } = useAuth()!;
  const access = accessType === 'E';

  const [ card, customers, cardGroups ] = await Promise.all([
    GetCardIndividual(cardNumber),
    GetCustomers(),
    GetCardGroups(customer)
  ]);

  const customerList = customers.body.map((r: any) => ({
    id: r.customerId,
    name: r.customerName
  }));
  dropdown(customerList, 'customer', 'Customer', true, true, access);

  const cardGroupList = cardGroups.body.map((r: any) => ({
    id: r.cardGroupId,
    name: r.cardGroupName
  }));
  dropdown(cardGroupList, 'card-group', 'Card Group', true, true, access);

  dropdown(CARD_FORM_STATUS, 'active', 'Status', false, true, access);

  const { body } = card;
  displayCardInfo(body);

  PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');

  const customerSelected = CARD_FORM.cardCustomer;
  const ObserverCustomer = new MutationObserver((mutRecords: any) => {
    for ( const { type, attributeName, target } of mutRecords ) {
      if ( type !== 'attributes' || attributeName !== 'data-value' ) {
        return;
      }
      if ( target.getAttribute( 'data-value' ) ) {
        CARD_FORM.cardCardGroup.innerText = 'Getting Card Group List...';
        let newCustomerID = String(customerSelected.getAttribute('data-value'));
        changeCustomerCardGroup(newCustomerID);        
      }
    }
  });

  ObserverCustomer.observe( customerSelected, { attributes: true });

  updateExistingCard();
}

export default HandleViewOrEditCard;